import { Slider } from "./Slider";
export { SliderSlide } from "./Slider";
export type { SliderProps } from "./Slider";
export { SliderControls, SliderControlTotalPages } from "./SliderControls";
export type { SliderControlsProps } from "./SliderControls";
export { EmotionalSlider } from "./EmotionalSlider";
export type { EmotionalSliderProps, EmotionalSliderAction } from "./EmotionalSlider";

export default Slider;
